/**
 * Javni URL sajta (bez završnog /). Podrazumevano produkcijski domen; REACT_APP_SITE_URL samo ako je drugačiji.
 */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://www.tcspp.rs').replace(
  /\/$/,
  ''
);

export const SITE_BRAND = 'THERMO COOL SYSTEM';

/** Jedinstven kanonski path: uvek sa vodećim /, bez završnog / (osim korena). */
export function normalizeSeoPath(path = '/') {
  if (!path || path === '/') return '/';
  let p = path.startsWith('/') ? path : `/${path}`;
  p = p.replace(/\/+$/, '');
  return p || '/';
}

export const absoluteUrl = (path) => {
  const norm = normalizeSeoPath(path);
  return norm === '/' ? SITE_URL : `${SITE_URL}${norm}`;
};

export const defaultOgImage = () => `${SITE_URL}/og-logo.jpg?v=1`;

export function canonicalUrl(path = '/') {
  const norm = normalizeSeoPath(path);
  return norm === '/' ? SITE_URL : `${SITE_URL}${norm}`;
}
